import {Component, EventEmitter, Input, OnInit, Output, OnDestroy} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {
    FORM_DIRECTIVES,
    FORM_PROVIDERS,
    REACTIVE_FORM_DIRECTIVES,
    FormControl,
    FormGroup,
    Validators
} from "@angular/forms";
import {AlertComponent, MODAL_DIRECTIVES, BS_VIEW_PROVIDERS, TYPEAHEAD_DIRECTIVES} from "ng2-bootstrap/ng2-bootstrap";
import {RolesService} from "../../service/roles.service";
import {OperatorsService} from "../../service/operators.service";
import {BankService} from "../../service/bank.service";
import {User} from "../../domain/user";
import {Rol} from "../../domain/rol";
import {Bank} from "../../domain/bank";
import {DEFAULT_ERROR_MESSAGES, EMAIL_VALIDATOR} from "../../validators/validators";
import {Response} from "@angular/http";
import {FormBuilder} from "@angular/common";

@Component({
    selector: 'operator-editor',
    template: require('./operator.editor.component.html'),
    directives: [
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        TYPEAHEAD_DIRECTIVES,
        MODAL_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        BS_VIEW_PROVIDERS
    ],
})
export class OperatorEditorComponent implements OnInit, OnDestroy {

    @Input() user:User;
    @Output() close = new EventEmitter();

    public errorMessages:any;
    public errorMessage:string;
    public successMessage:string;

    private sub:any;
    public form:FormGroup;

    private userId:string;

    public createMode:boolean;
    public loading:boolean = false;

    public banks:Bank[];
    public roles:Rol[];

    public bankSelectedId:string;
    public rolSelectedId:string;

    private changePassword:boolean;
    private userLoaded:boolean;

    private usernameDuplicate:boolean;

    constructor(private rolesService:RolesService,
                private operatorsService:OperatorsService,
                private bankService:BankService,
                private route:ActivatedRoute) {
        this.init();
    }

    private init():void {
        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.user = new User();
        this.bankSelectedId = '';

        this.loading = false;

        this.banks = [];
        this.roles = [];

        this.changePassword = false;
        this.userLoaded = false;

        this.usernameDuplicate = false;
    }

    public ngOnInit() {
        this.createFormGroup();

        this.sub = this.route.params.subscribe(params => {
            let userId = params['userId'];
            if (userId) {
                this.userId = userId;
                this.createMode = false;
            } else {
                this.userId = null;
                this.createMode = true;
            }
            this.getData();
        });
    }

    public ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private passwordAreEqual(group:FormControl):any {
        if (!this.userLoaded || (this.user.id && !this.changePassword)) {
            return null;
        }

        var val1 = this.user.password;
        var val2 = this.user.repeatPassword;
        if ((!val1 && !val2 ) || val1 === val2) {
            return null;
        }

        return {
            areEqual: true
        };
    }

    public triggerPasswordValidators():void {
        this.form.controls['password'].updateValueAndValidity();
        this.form.controls['repeatPassword'].updateValueAndValidity();
    }

    private validatePasswordRequired(group:FormControl):any {
        if (!this.userLoaded || (this.user.id && !this.changePassword)) {
            return null;
        }

        var val = group.value;
        if (!val || val === '') {
            return {
                required: true
            };
        }
        return null;
    }

    private validatePasswordMinLength(group:FormControl):any {
        if (!this.userLoaded || (this.user.id && !this.changePassword)) {
            return null;
        }

        var val = group.value;
        if (val && val.length > 0 && val.length < 6) {
            return {
                minLength: true
            };
        }
        return null;
    }

    private createFormGroup():void {
        let group:any = {};
        group['username'] = new FormControl(null, Validators.required);
        group['name'] = new FormControl(null, Validators.required);
        group['surname'] = new FormControl(null, Validators.required);
        group['email'] = new FormControl(null, [Validators.required, EMAIL_VALIDATOR]);
        group['rol'] = new FormControl(null, Validators.required);
        group['bank'] = new FormControl();
        group['enabled'] = new FormControl();
        group['password'] = new FormControl('', [this.validatePasswordRequired.bind(this), this.validatePasswordMinLength.bind(this), this.passwordAreEqual.bind(this)]);
        group['repeatPassword'] = new FormControl('', [this.validatePasswordRequired.bind(this), this.validatePasswordMinLength.bind(this), this.passwordAreEqual.bind(this)]);
        this.form = new FormGroup(group);
    }

    private getData():void {
        this.loading = true;

        let forkTasks:Observable<any>[] = [];
        forkTasks.push(this.rolesService.getRoles());
        forkTasks.push(this.bankService.getBanks());
        if (this.userId) {
            forkTasks.push(this.operatorsService.getUser(this.userId));
        } else {
            forkTasks.push(this.operatorsService.getNewUser());
        }
        Observable.forkJoin(forkTasks).subscribe(
            this.setData.bind(this),
            () => {
                this.bindError('Ocurrió un error al obtener los datos del usuario.');
            });
    }

    private setData(data:any[]):void {
        this.loading = false;
        this.roles = data[0];
        this.banks = data[1];
        this.user = new User(data[data.length - 1]);

        this.bankSelectedId = (this.user.bank) ? this.user.bank.id : '';
        this.rolSelectedId = (this.user.rol) ? this.user.rol.id : null;
        this.userLoaded = true;
        this.user.password = '';
        this.user.repeatPassword = '';
        //this.form.controls['password'].value = '';
        //this.form.controls['repeatPassword'].value = '';
    }

    public save():void {
        this.clearMessages();
        this.loading = true;
        if (this.user.id && !this.changePassword) {
            this.user.password = null;
            this.user.repeatPassword = null;
        }

        this.operatorsService.save(this.user).subscribe(
            (saved:User) => {
                this.loading = false;
                this.user = saved;
                this.changePassword = false;
                this.successMessage = 'El usuario se guardó con éxito';
            },
            () => {
                this.bindError('Ocurrió un error al guardar los datos del usuario.');
            });
    }

    private clearMessages():void {
        this.successMessage = null;
        this.errorMessage = null;
    }

    public goBack(event:any):void {
        event.preventDefault();
        this.close.emit(this.user);
        window.history.back();
    }

    public updateRolSelected(target:any):void {
        let value = target.value;
        if (value) {
            this.user.rol = this.roles.filter(
                (rol)=> {
                    return rol.id == value
                })[0];
        } else {
            this.user.rol = null;
        }
    }

    public updateBankSelected(target:any):void {
        let value = target.value;
        if (value) {
            this.user.bank = this.banks.filter(
                (bank)=> {
                    return bank.id == value
                })[0];
        } else {
            this.user.bank = null;
        }
    }

    public validateUsername():void {
        this.errorMessage = null;
        this.operatorsService.getUserByUsername(this.user.username).subscribe(
            (user)=> {
                this.usernameDuplicate = !!(user && user.username);
            },
            (error) => {
                this.bindError('Ocurrió un error al validar username existente.');
                this.usernameDuplicate = false;
            });
    }

    private bindError(messageError:string):void {
        this.loading = false;
        if (this.errorMessage == null) {
            this.errorMessage = messageError;
        } else {
            this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/config/operators/operator.editor.component.ts
 **/